import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from 'cn';
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverClose = PopoverPrimitive.Close;

// Radix Select renders its dropdown in its own Portal, which is a sibling of
// the Popover's Portal under document.body. That means a click on the Select
// dropdown looks "outside" to the Popover's DismissableLayer, and the Popover
// closes (browser-dependent because pointerdown timing varies). Suppress
// dismissal when the event target is inside any portaled Select content.
// `data-slot="select-content"` is set on the shared SelectContent and wraps
// both the items and the scroll buttons (the year list can scroll).
// See radix-ui/primitives#2224 and #3166.
const isInsideSelectContent = (target: EventTarget | null) => {
  if (!(target instanceof Element)) return false;
  return target.closest('[data-slot="select-content"]') !== null;
};
const PopoverContent = React.forwardRef<React.ComponentRef<typeof PopoverPrimitive.Content>, React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>>(({
  className,
  align = 'center',
  sideOffset = 4,
  onPointerDownOutside,
  onFocusOutside,
  ...props
}, ref) => <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content ref={ref} align={align} sideOffset={sideOffset}
  // Same Chrome Translate / React portal removeChild failure mode as
  // Select (PORTAL-1CT / PORTAL-18A). Task filters use Popover for
  // people pickers.
  translate="no" onPointerDownOutside={event => {
    onPointerDownOutside?.(event);
    if (!event.defaultPrevented && isInsideSelectContent(event.target)) {
      event.preventDefault();
    }
  }} onFocusOutside={event => {
    onFocusOutside?.(event);
    if (!event.defaultPrevented && isInsideSelectContent(event.target)) {
      event.preventDefault();
    }
  }} className={cn('bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 rounded-md border p-4 shadow-md outline-hidden', className)} {...props} />
    </PopoverPrimitive.Portal>);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
export { Popover, PopoverAnchor, PopoverClose, PopoverContent, PopoverTrigger };